export type KontaktTab = 'privatperson' | 'unternehmen';

export interface KontaktFormFelder {
  activeTab: KontaktTab;
  anrede: string;
  vorname: string;
  nachname: string;
  kontaktart: string;
  geburtsdatum: string;
  unternehmensart: string;
  firmenname: string;
  strasse: string;
  hausnummer: string;
  plz: string;
  stadt: string;
  land: string;
  email: string;
  festnetz: string;
  handynummer: string;
  kontoinhaber: string;
  bank: string;
  iban: string;
  bic: string;
  steuernummer: string;
  ustIdNr: string;
  glaeubigerId: string;
}

/** Insert/Update-Payload für die Tabelle `kontakte` (Erstellen- und Edit-Formular). */
export function baueKontaktPayload(f: KontaktFormFelder): Record<string, any> {
  const privat = f.activeTab === 'privatperson';
  return {
    typ: privat ? (f.kontaktart || 'Sonstige') : (f.unternehmensart || 'Sonstige'),
    anrede: f.anrede || null,
    vorname: privat ? (f.vorname.trim() || null) : null,
    nachname: privat ? f.nachname.trim() : null,
    firma_name: privat ? null : f.firmenname.trim(),
    kontaktart: privat ? (f.kontaktart || null) : null,
    unternehmensart: privat ? null : (f.unternehmensart || null),
    geburtsdatum: f.geburtsdatum || null,
    strasse: f.strasse.trim() || null,
    hausnummer: f.hausnummer.trim() || null,
    plz: f.plz.trim() || null,
    stadt: f.stadt.trim() || null,
    land: f.land || null,
    email: f.email.trim() || null,
    festnetz: f.festnetz.trim() || null,
    handynummer: f.handynummer.trim() || null,
    kontoinhaber: f.kontoinhaber.trim() || null,
    bank: f.bank.trim() || null,
    iban: f.iban.trim() || null,
    bic: f.bic.trim() || null,
    steuernummer: f.steuernummer.trim() || null,
    ust_id_nr: f.ustIdNr.trim() || null,
    glaeubiger_id: f.glaeubigerId.trim() || null,
  };
}

/** Formular-Tab-Vorauswahl anhand einer bestehenden kontakte-Zeile. */
export function tabAusKontakt(kontakt: { firma_name?: string | null }): KontaktTab {
  return kontakt.firma_name ? 'unternehmen' : 'privatperson';
}

export type KontaktPflichtfeld = 'nachname' | 'firmenname';

/** Pflichtfeld-Prüfung (Texte wie bisher in den alert()-Meldungen); null = in Ordnung. */
export function pflichtfeldFehler(f: Pick<KontaktFormFelder, 'activeTab' | 'nachname' | 'firmenname'>): { feld: KontaktPflichtfeld; text: string } | null {
  if (f.activeTab === 'privatperson' && !f.nachname.trim()) return { feld: 'nachname', text: 'Bitte geben Sie mindestens einen Nachnamen ein.' };
  if (f.activeTab === 'unternehmen' && !f.firmenname.trim()) return { feld: 'firmenname', text: 'Bitte geben Sie einen Firmennamen ein.' };
  return null;
}
